import { AIConnection } from "@/lib/ai/ai-connection"
import { AIMaskResolver } from "./ai-mask-resolver"
import { MainMaskCache } from "@/storage/mask-cache"

function getAIProxy() {
	const proxy = AIConnection.proxy
	if (!proxy) {
		throw new Error("AI connection is unavailable")
	}
	return proxy
}

// Main thread (default) mask resolver
export const MainAIMaskResolver = new AIMaskResolver(
	{
		getSubjectMask: async (inputImage?: ImageBitmap, adjustedGamma?: number) => {
			const result = await getAIProxy().getSubjectMask(inputImage, adjustedGamma)
			return result ?? null
		},
		getSkyMask: async (inputImage?: ImageBitmap) => {
			const result = await getAIProxy().getSkyMask(inputImage)
			return result ?? null
		},
		getPeopleSegmentation: async (inputImage, options) => {
			const result = await getAIProxy().getPeopleSegmentation(inputImage, options)
			return result ?? null
		},
		getFaceParsing: async (inputImage, faceRect, confidenceThreshold) => {
			const result = await getAIProxy().getFaceParsing(
				inputImage,
				faceRect,
				confidenceThreshold,
			)
			return result ?? null
		},
		getHumanParsing: async (inputImage, personBox) => {
			const result = await getAIProxy().getHumanParsing(inputImage, personBox)
			return result ?? null
		},
	},
	"main",
	MainMaskCache,
)
